import { Children, type ReactNode } from 'react';
import Box from '@mui/material/Box';

/**
 * One row of a record form: stacked on mobile, split into as many equal columns
 * as it has children from `sm` up.
 *
 * The Befund forms are field-dense — a flat single column makes them a long
 * scroll of near-identical inputs. Column count comes from the child count, so
 * a row's shape is visible at the call site; give a field a row of its own to
 * keep it full width.
 */
export default function FormRow({
    children,
    columns: template
}: {
    children: ReactNode;
    /**
     * Columns where the default (stacked, then equal) doesn't fit — e.g. two
     * short time fields that stay side by side even on a phone.
     */
    columns?: { xs?: string; sm?: string };
}) {
    const columns = Children.count(children);
    return (
        <Box
            sx={{
                display: 'grid',
                gap: 2,
                gridTemplateColumns: {
                    xs: template?.xs ?? '1fr',
                    sm: template?.sm ?? `repeat(${columns}, 1fr)`
                },
                // Inputs carrying a helper text must not shift their neighbours.
                alignItems: 'start'
            }}
        >
            {children}
        </Box>
    );
}
